import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core/styles';
import Entry from './Entry';


export function LogbookEntry(props) {
  const {
    logbook, theme, onDateSelected, focused,
  } = props;

  const ignoredKeys = ['id', 'date', 'elephant', 'type'];
  const logbookDetails = Object.keys(logbook).map((key) => {
    if (ignoredKeys.find(k => k === key)) return null;
    const value = logbook[key];
    if (!value) return null;
    return {
      key,
      value,
    };
  }).filter(i => i !== null);

  const rowColor = theme.logbook.palette.logbookEntry;

  return (
    <Entry
      focused={focused}
      onDateSelected={onDateSelected}
      style={{ backgroundColor: rowColor }}
      date={logbook.date}
      details={logbookDetails}
      type="logbook"
    />
  );
}

LogbookEntry.propTypes = {
  logbook: PropTypes.shape().isRequired,
  theme: PropTypes.shape().isRequired,
  onDateSelected: PropTypes.func,
  focused: PropTypes.bool,
};
LogbookEntry.defaultProps = {
  onDateSelected: () => {},
  focused: false,
};


export default withTheme()(LogbookEntry);



// WEBPACK FOOTER //
// ./src/layout/logbook/LogbookEntry.jsx